<template>
  <footer><div class="container">
    <span>Version v0.12.1 (11/20/24)</span> -
    <a href="https://api.tagforest.fr">REST API</a> -
    <a href="https://github.com/jhg8/tagforest">Github</a>
  </div></footer>
</template>
